import {
  SET_PROFILE_DATA,
  SET_ORGANISATION_DATA,
  SET_ORGANISATION_LOGO,
  LOAD_INDUSTRY_LIST,
  LOAD_ORG_DISTRIBUTOR_LIST,
  LOAD_ORG_DATA,
  LOAD_ORG_PARENT_COMPANY_LIST,
  LOAD_ORG_LANGUAGE_LIST,
  LOAD_ORG_COUNTRY_LIST,
  SET_TEAM_PROFILE_DATA,
  LOAD_ORGANISATION_OPTIONS,
  SET_ACTIVITY_DATA,
} from "./types";

const initialState = {
  full_name: "",
  email: "",
  alter_email: "",
  mobile_number: "",
  role: "",
  department: "",
  company_position: "",
  qualification: "",
  reporting_manager: "",
  profile_pic: "",
  reporting_manager_status: false,
  image_popup: false,
  delete_popup: true,
  save_profile_btn_disable: false,
  profile_data_Refetch: false,
  profile_pic_state: "",
  profile_pic_upload_percentage: 0,
  isProfileDataLoading: true,
  profile_upload_btn_disable: false,
  profile_dlt_btn_disable: false,
  profile_404: false,
  isMobileData: false,
  login_activity: [],

  //organisation
  org_name: "",
  org_prmry_lan: "",
  org_type: "",
  org_region: "",
  org_cmpny_reg: "",
  org_web: "",
  org_vat_num: "",
  org_turnover: "",
  org_tel_no: "",
  org_employees: "",
  org_vendor_accred: "",
  org_accounts_field: "",
  org_email_domain: "",
  org_classification: "",
  org_reg_address: "",
  org_company_overview: "",
  add_org_logo_popup: false,
  org_add_logo: null,
  industry_list: [],
  org_industry_id: "",
  org_distributor_list: [],
  org_data: [],
  org_refetch: true,
  org_distributor: {},
  org_parent_cmpny: {},
  org_cntry_optn_id: "",
  org_parent_companies: [],
  org_parent_cmpny_status: true,
  org_distributor_status: true,
  org_languages: [],
  org_countries: [],
  file_upload_percentage: 0,
  org_logo_name: "",
  delete_logo_pop: true,
  org_submit_btn_disable: false,
  isOrgDataLoading: true,
  org_upload_btn_disable: false,
  org_distributor_name: "",
  delete_logo_disable: false,
  add_org_otp_popup: false,
  org_resend_enable: true,
  org_otp: "",
  org_option_list: {},
  disable_otp_popup: false,
  org_email_domain_check: "",

  //team_profile
  pr_full_name: "",
  pr_email: "",
  pr_alter_email: "",
  pr_mobile_number: "",
  pr_role: "",
  pr_department: "",
  pr_company_position: "",
  pr_qualification: "",
  pr_reporting_manager: "",
  pr_pic: "",
  pr_reporting_manager_status: false,
  pr_image_popup: false,
  pr_delete_popup: true,
  pr_save_btn_disable: false,
  pr_data_Refetch: false,
  pr_pic_state: "",
  pr_pic_upload_percentage: 0,
  pr_isProfileDataLoading: true,
  pr_upload_btn_disable: false,
  pr_dlt_btn_disable: false,
  pr_404: false,
  disable_team_otp_popup: false,
  pr_mobile_number_check: "",
  user_roles: [],

  // organisationalActivity
  organisationalActivityPivot: "0",
  organisationalActivity: [],
  isOrganisationalActivityLoading: true,
  refetchOrganisationalActivity: true,
  showfilter: false,
  options: [],
  activityStartDate: "",
  activityEndDate: "",
  activitySelected: "",
  EndActivity: "",
  StartActivity: "",
  orgidActivity: "",
  total_activity_records: 0,
  current_page: 1,
  offset_value: 40,
  show_profile_nav_popup: false,
  service_charge: "",
  profile_partner_id: "",

  /* Active deal users */
  addDealUserPopup: false,
  addDealUserPopupDisable: false,
  addDealSearch: "",
  allDealUsers: [],
  allDealUsersTotalCount: 0,
  dealUserPage: 1,
  dealUserPerPage: 20,
  dealUserRefetch: false,
  activeDealLoading: false,
  editDealUser: {},
  isEditMode: false,
  dealDealUserPopupDisable: false,
  deleteDealUserPopup: false,
  deleteDealUser: {},
  nameUser: "",
  emailUser: "",
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_PROFILE_DATA:
      return { ...state, ...action.payload };

    //organisation
    case SET_ORGANISATION_DATA:
      return { ...state, ...action.payload };
    case SET_ORGANISATION_LOGO:
      return { ...state, ...action.payload };
    case LOAD_INDUSTRY_LIST: {
      return { ...state, industry_list: action.payload };
    }
    case LOAD_ORG_DISTRIBUTOR_LIST: {
      return { ...state, org_distributor_list: action.payload };
    }
    case LOAD_ORG_DATA: {
      return {
        ...state,
        org_data: action.payload,
        org_name: action.payload.org_name,
      };
    }
    case LOAD_ORGANISATION_OPTIONS: {
      return { ...state, org_option_list: action.payload };
    }
    case LOAD_ORG_PARENT_COMPANY_LIST: {
      return { ...state, org_parent_companies: action.payload };
    }
    case LOAD_ORG_LANGUAGE_LIST: {
      return { ...state, org_languages: action.payload };
    }
    case LOAD_ORG_COUNTRY_LIST: {
      return { ...state, org_countries: action.payload };
    }
    //organisation

    case SET_TEAM_PROFILE_DATA:
      return { ...state, ...action.payload };

    case SET_ACTIVITY_DATA: {
      return { ...state, ...action.payload };
    }

    default:
      return state;
  }
};
